import { cn } from '@@/lib/utils';
import { lazy, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import '@@/ui/theme/shadcn.css';
import { useGlobal } from '@@/contexts/GlobalProvider';

const TopBar = lazy(() => import('@@/products/cases/layout/TopBar'));

const SideBar = lazy(() => import('@@/products/cases/layout/SideBar'));

const CasesWrapper = () => {
  const { isSideNavExpanded, toggleSideNav, setColorScheme } = useGlobal();
  useEffect(() => {
    setColorScheme('cxcentral');
  }, []);

  return (
    <>
      <TopBar onMenuClick={toggleSideNav} isExpanded={isSideNavExpanded} />
      <SideBar
        isExpanded={isSideNavExpanded}
        setIsExpanded={(expanded) => isSideNavExpanded !== expanded && toggleSideNav()}
      />
      <main
        className={cn(
          'transition-all duration-300 h-[calc(100vh-3rem)] overflow-auto absolute top-12 scrollbar-custom font-mona',
          isSideNavExpanded ? 'w-[calc(100%-12rem)] ml-48' : 'w-[calc(100%-43px)] ml-[43px]'
        )}
      >
        <Outlet />
      </main>
    </>
  );
};

export default CasesWrapper;
